import request from "@/plugins/axios";

export class DictionaryApis {
  /*
   * 获取字典分类列表
   * @param dictTypeName 分类名称   可空参数
   * */
  static dictionaryTypeList(dictTypeName) {
    return request.get(`/DictionaryType/DictionaryTypeList`, { dictTypeName });
  }

  /*
   * 根据字典分类id获取字典列表
   * @param dictTypeId 分类id
   * @param dictName 字典名称 搜索关键字
   * @param pages 分页
   * */
  static dictionaryInfoPageList(dictTypeId, dictName, pages) {
    return request.get(`/DictionaryInfo/DictionaryInfoPageList?dictTypeId=${dictTypeId}&dictName=${dictName}&pageIndex=${pages.currentPage}&pageSize=${pages.pageSize}`);
  }

  /*
   * 根据字典分类添加字典
   * @param dictTypeId 分类id
   * @param dictName 字典名称
   * */
  static addDictionaryInfo(dictTypeId, dictName) {
    return request.post(`/DictionaryInfo/AddDictionaryInfo`, { dictTypeId, dictName });
  }

  /*
   * 根据字典分类修改字典
   * @param dictTypeId 分类id
   * @param id 当前字典的id
   * @param dictName 字典名称
   * */
  static modifyDictionaryInfo(dictTypeId, id, dictName) {
    return request.post(`/DictionaryInfo/ModifyDictionaryInfo`, { dictTypeId, id, dictName });
  }

  /*
   * 删除字典
   * @param id 当前字典的id
   * */
  static delDictionaryInfo(id) {
    return request.delete(`/DictionaryInfo/DelDictionaryInfo?id=${id}`);
  }

  /*
   * 根据字典值获取字典选项
   * @param key 当前字典的key值
   * */
  static async getDictValueByKey(key) {
    // Store.state
    let vals = this[`${key}Vals`];
    if (vals) return vals;
    return request.get(`/Crm/Dictionary/ManageGetDicValueByDicKey?dicKey=${key}`).then((res) => {
      this[`${key}Vals`] = res;
      return res;
    });
  }
}
